module.exports = __webpack_public_path__ + "img/payment_mb_06.09626529.png";